import { ArrowBack as BackIcon, ArrowForward as ForwardIcon } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';

import type { StepFooterProps } from './types';

export const StepFooter: React.FC<StepFooterProps> = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  nextLabel = 'Next',
  nextDisabled = false,
  showBack = true,
  showNext = true,
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      {/* Dot indicators */}
      <Stack direction="row" spacing={0.75}>
        {Array.from({ length: totalSteps }, (_, i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: i === currentStep ? 'primary.main' : 'grey.400',
              transition: 'background-color 0.2s',
            }}
          />
        ))}
      </Stack>

      {/* Navigation buttons */}
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
        {showBack && currentStep > 0 && (
          <Button
            onClick={onBack}
            startIcon={<BackIcon />}
            sx={{ textTransform: 'none', color: 'text.primary' }}
          >
            Back
          </Button>
        )}
        {showNext && (
          <Button
            variant="contained"
            onClick={() => {
              void onNext();
            }}
            disabled={nextDisabled}
            endIcon={nextLabel === 'Next' ? <ForwardIcon /> : undefined}
            sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
          >
            {nextLabel}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
